import { render } from "./ModalContainer.vue?vue&type=template&id=23e80476&ts=true"
import script from "./ModalContainer.vue?vue&type=script&lang=ts"
export * from "./ModalContainer.vue?vue&type=script&lang=ts"

import "./ModalContainer.vue?vue&type=style&index=0&id=23e80476&lang=less"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__